import { defineStyle } from '@chakra-ui/react';

export const primaryVariant = defineStyle({
  rounded: 'none',
  color: 'neutral.white',
  backgroundColor: 'blue.600',
  fontFamily: 'space',
  fontFeatureSettings: "'liga' off",
  border: '2px solid',
  borderRadius: 0,
  borderColor: 'blue.600 !important',
  boxShadow: 'inset 0 0 0 2px var(--chakra-colors-neutral-900)',
  _hover: {
    backgroundColor: 'blue',
    _disabled: {
      backgroundColor: 'neutral.900',
    },
  },
  _disabled: {
    cursor: 'default',
    color: 'neutral.500',
    backgroundColor: 'neutral.900',
    borderColor: 'neutral.900-op30 !important',
    opacity: 1,
  },
});
